import {isEmpty as _isEmpty} from 'lodash';
import React from 'react';

import {findById, parseReferences} from '@modules/client/utils/thirdPartyTunnelHelper';
import LinkWithAuthorization from '@appComponents/LinkWithAuthorization';
import {THIRD_PARTY_CLIENT_TUNNEL} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ} from '@constants/variables';
import {IconEdit, IconSquare} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import Authorization from '@appComponents/Authorization';
import {TunnelStatus} from '@utils/tableHelpers';

export const thirdPartyTunnelsRowRenderer = (column, row, props) => {
    let vtdTunnel = findById(props.vtdTunnels, row.vtd_tunnel_id);

    switch (column) {
        case 'id':
            return row.id ? row.id : '';
        case 'name':
            return (
                <div>
                    <div>
                        {(_isEmpty(row.name))
                            ? ''
                            :
                            <LinkWithAuthorization
                                resources={THIRD_PARTY_CLIENT_TUNNEL}
                                privileges={SECURITY_PRIVILEGES_READ}
                                link={{
                                    name: 'clients.products.thirdParty.tunnels.edit',
                                    params: {
                                        id: props.clientId,
                                        thirdPartyClientTunnelId: row.id,
                                    },
                                }}
                            >
                                {row.name}
                            </LinkWithAuthorization>
                        }
                        {(!row.is_placeholder_for_auto_assignment)
                            ? ''
                            :
                            <span className='--customIcon-margin-left-5'>
                                <IconSquare name='cogs'/>
                            </span>
                        }
                    </div>
                    <div>
                        {(!_isEmpty(row.description)) && <p className='muted'>{row.description}</p>}
                    </div>
                </div>
            );
        case 'vtd_tunnel':
            return vtdTunnel?.name || '';
        case 'vtd_tunnel_status':
            return <div>
                { !row.is_placeholder_for_auto_assignment ?
                    <TunnelStatus isStarted={!!vtdTunnel?.started} /> : ''
                }
            </div>;
        case 'encoding_job_profile':
            return row[column].name;
        case 'output_client_reference':
            return parseReferences(row.output_references);
        case 'actions': {
            return (
                <Authorization
                    privileges={SECURITY_PRIVILEGES_READ}
                    resources={THIRD_PARTY_CLIENT_TUNNEL}
                >
                    <div className='actions-list-icon'>
                        <IconEdit
                            link={getLink('clients.products.thirdParty.tunnels.edit', {
                                id: props.clientId,
                                thirdPartyClientTunnelId: row.id,
                            })}
                            size='large'
                            resource={THIRD_PARTY_CLIENT_TUNNEL}/>
                    </div>
                </Authorization>
            );
        }
        default: {
            return null;
        }
    }
};
